export default [
  {
    link: 'https://help.zola.com/hc/en-us/articles/115002839971-What-is-the-free-shipping-policy-',
    icon: 'zolaicon-fast-shipping',
    title: 'Free Shipping & Returns',
    subTitle: 'details',
  },
  {
    link: 'https://help.zola.com/hc/en-us/articles/115002838511-Does-Zola-offer-price-matching-',
    icon: 'zolaicon-customer-service',
    title: 'Price Matching',
    subTitle: 'details',
  },
  {
    link: '/wedding-registry/benefits/registry-completion-discount',
    icon: 'zolaicon-post-wedding-discount',
    title: 'Post-Wedding Discount',
    subTitle: 'details',
  },
];

export const weddingShopBannerData = [
  {
    link: 'https://help.zola.com/hc/en-us/articles/115002839971-What-is-the-free-shipping-policy-',
    icon: 'zolaicon-fast-shipping',
    title: 'Free Shipping & Returns',
    subTitle: 'details',
  },
  {
    link: 'https://help.zola.com/hc/en-us/articles/115002838511-Does-Zola-offer-price-matching-',
    icon: 'zolaicon-customer-service',
    title: 'Price Matching',
    subTitle: 'details',
  },
  {
    link: '/shop/brands/wedding-shop',
    icon: 'zolaicon-best-brand-gifts',
    title: "Today's Best Wedding Brands",
    subTitle: 'details',
  },
];
